module.exports = __webpack_public_path__ + "img/tianBao.3df6463a.png";